import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { Switch } from '@headlessui/react';

interface ToggleSwitchRowProps<T extends FieldValues> {
  control: Control<T>;
  name: Path<T>;
  label: string;
}

const ToggleSwitchRow = <T extends FieldValues>({
  control,
  name,
  label,
}: ToggleSwitchRowProps<T>) => (
  <Switch.Group as="div" className="flex justify-between items-center">
    <Switch.Label className="font-bold text-16 leading-[2.4rem]">
      {label}
    </Switch.Label>
    <div className="flex gap-x-1.6 items-center">
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <>
            <Switch
              onChange={field.onChange}
              onBlur={field.onBlur}
              checked={Boolean(field.value)}
              className={`${
                field.value ? 'bg-magenta' : 'bg-[#78788029]'
              } relative inline-flex h-2.4 w-4 items-center rounded-full`}
            >
              <span
                className={`${
                  field.value ? 'translate-x-[1.8rem]' : 'translate-x-[2px]'
                } inline-block h-2 w-2 transform rounded-full transition bg-white`}
              />
            </Switch>
            <span className="uppercase">{field.value ? 'On' : 'Off'}</span>
          </>
        )}
      />
    </div>
  </Switch.Group>
);

export default ToggleSwitchRow;
